const ztmslg = require.context(
  '@assets/image/officialStore/ztmslg',
  true,
  /.(png|jp?eg|gif)$/
)
const ztmslgImgObj = {}
ztmslg.keys().forEach(path => {
  const file_name = path.replace(/(.*\/)*([^.]+).*/gi, '$2')
  const file = ztmslg(path).default || ztmslg(path)
  ztmslgImgObj[file_name] = file
})

const antslg = require.context(
  '@assets/image/officialStore/antslg',
  true,
  /.(png|jp?eg|gif)$/
)
const antslgImgObj = {}
antslg.keys().forEach(path => {
  const file_name = path.replace(/(.*\/)*([^.]+).*/gi, '$2')
  const file = antslg(path).default || antslg(path)
  antslgImgObj[file_name] = file
})

const dzg = require.context(
  '@assets/image/officialStore/dzg',
  true,
  /.(png|jp?eg|gif)$/
)
const dzgImgObj = {}
dzg.keys().forEach(path => {
  const file_name = path.replace(/(.*\/)*([^.]+).*/gi, '$2')
  const file = dzg(path).default || dzg(path)
  dzgImgObj[file_name] = file
})

const dtmslg = require.context(
  '@assets/image/officialStore/dtmslg',
  true,
  /.(png|jp?eg|gif)$/
)
const dtmslgImgObj = {}
dtmslg.keys().forEach(path => {
  const file_name = path.replace(/(.*\/)*([^.]+).*/gi, '$2')
  const file = dtmslg(path).default || dtmslg(path)
  dtmslgImgObj[file_name] = file
})

const globalImgConfig = {
  ztmslg: ztmslgImgObj,
  antslg: antslgImgObj,
  dzg: dzgImgObj,
  dtmslg: dtmslgImgObj,
  beauty: dzgImgObj, // TOTO
  defaultGameImgCode: 'ztmslg'
}

export const preloadImg = gameCode => {
  Object.keys(globalImgConfig[gameCode]).forEach(img => {
    let newImg = new Image()
    newImg.src = globalImgConfig[gameCode][img]
  })
}

export default globalImgConfig
